import React, { useState, useEffect }  from 'react';
// import { AuthContext } from '../AuthProvider';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 
import './mycss.css';
import Apiconnect from "../services/Apiconnect.js"; 


const Verify = () => {
      const [bgimg, setBgimg] = useState('');
      const [txtone, setTxtone] = useState('');
      const [txttwo, setTxttwo] = useState('');

      const { vid } = useParams();
       
       
      const navigate  = useNavigate(); 

      useEffect(() => { 
          
         const randomImageUrl = getRandomImage();
         setBgimg (randomImageUrl);
         handleSubmit();    
     }, [setBgimg]);
  
      const getRandomImage = () => {
         const randomNum = Math.floor(Math.random() * 9) + 1; // Generates a number between 1 and 9
         return `/admin_codebase/bgpic${randomNum}.jpg`;
      };
       

      const handleSubmit = async e => {


            try {
                  await Apiconnect.getDataNoauth("verify/"+vid).then((response) => { 
                     console.log(response.data); 
                     if(response.data.status==1)  {
                        setTxtone('Awesome');
                     }else{
                        setTxtone('Error');
                     } 
                  });
            } catch (error) {
                  setTxtone('Process Error');
                  var err = 'Somthing went wrong!!';
                  if (error.response) {
                     console.log('Response error:', error.response.data);
                     console.log('Response status:', error.response.status);
                     console.log('Response headers:', error.response.headers);                  
                  } else if (error.request) {
                     console.log('Request error:', error.request);
                  } else {
                     console.log('General error:', error.message);
                  }

                  toast.error(err);
            }
        
         
         


      
                 
        
       };
       
       


  return (
    <>
     

                           
         <div class="container-fluid p-0 vh-100"  >
            <div class="row g-0 vh-100">
            <div class="col-xl-7 example" 
               style={{                   
                  backgroundImage: `url(${bgimg})`, 
                  }} 
                  
                  >
                   
               </div>  
               
               <div class="col-xl-5 vh-100" >
                  <div class="auth-full-page-content p-md-5 p-4"  >
                        <div class="w-100 p-5" >

                           <div class="text-center">
                                 <img style={{maxWidth:'50%', marginBottom:30, }} src="/admin_codebase/b-logo.png" />
                                 
                                 <h2><b>{txtone}</b></h2>
                                 <h6>{txttwo}</h6>




                                 <a href="/">Back to Login</a>
                           </div>

                           

                        

                           

                           
                        </div>
                  </div>
               </div> 
            </div>
         </div>
      

         <ToastContainer />
    </>
  );
};

export default Verify;
